import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { analytics } from '@/utils/analytics';
import { metaPixel } from '@/utils/meta-pixel';

export const CTA: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-green-600 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-tight uppercase">
          Optimisez vos travaux énergétiques dès maintenant
        </h2>
        <div className="w-12 h-0.5 bg-white mx-auto mb-6"></div>
        
        <p className="text-lg text-white/90 mb-8 max-w-4xl mx-auto">
          Rejoignez des centaines de propriétaires qui testent leurs hypothèses de travaux 
          et découvrent l'impact exact sur leur DPE avant d'investir
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          <Button
            size="lg"
            variant="outline"
            className="bg-white text-blue-600 border-white hover:bg-blue-50"
            onClick={() => {
              // Track pricing CTA click for non-authenticated users
              if (!isAuthenticated) {
                metaPixel.trackPricingCTA();
              }
              if (isAuthenticated) {
                navigate('/pricing');
              } else {
                navigate('/auth?mode=signup&redirect=/pricing');
              }
            }}
          >
            Analyser Mon DPE Maintenant
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          {/*
          <Button
            size="lg"
            variant="ghost"
            className="text-white border-2 border-white hover:bg-white/10"
            onClick={() => {
              // Track download event
              analytics.trackEvent({
                action: 'download',
                category: 'engagement',
                label: 'example_analysis_pdf'
              });
              
              // Track with Meta Pixel
              metaPixel.trackEvent('ViewContent', {
                content_name: 'Example Analysis PDF',
                content_category: 'download'
              });
              
              // Create download link and trigger download
              const link = document.createElement('a');
              link.href = '/assets/DPEWizard_Exemple_rapport_analyse_DPE.pdf';
              link.download = 'DPEWizard_Exemple_rapport_analyse_DPE.pdf';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Voir un Exemple d'Analyse
          </Button>
          */}
        </div>
      </div>
    </section>
  );
};

export default CTA;